module.exports = __webpack_public_path__ + "img/caja-paso-4.2ee78fa4.svg";